import type { IService } from '../../types';
import * as m from '@/paraglide/messages.js';
import HealthNavIcon from '@/assets/icons/platform-white.svg';
import HealthNavBanner from '@/assets/banners/health-navigation-platform.jpg';
import HealthNavNavIcon from '@/assets/icons/platform-purple.svg';
import TelemedicineIcon from '@/assets/icons/telemedicine-white.svg';
import TelemedicineBanner from '@/assets/banners/telemedicine-card.jpg';
import TelemedicineNavIcon from '@/assets/icons/telemedicine.svg';
import LegarooNavIcon from '@/assets/icons/legal-support-purple.svg';
import LegarooIcon from '@/assets/icons/legal-support-white.svg';
import LegarooBanner from '@/assets/banners/legaroo-banner.png';

export const getServices = (): IService[] => [
  {
    name: m.service_telemedicine_name(),
    href: '/services/telemedicine',
    navIcon: TelemedicineNavIcon,
    dashboardIcon: TelemedicineIcon,
    dashboardBanner: TelemedicineBanner,
    description: m.service_telemedicine_description(),
    ariaLabel: m.service_telemedicine_aria(),
    landingBrandName: 'Telus Health',
    landingTagline: m.service_telemedicine_landing_tagline(),
    landingTitle: m.service_telemedicine_landing_title(),
    landingFeatures: [],
    landingLearnMoreLabel: m.service_telemedicine_landing_btn(),
  },
  {
    name: m.service_health_nav_name(),
    href: '/services/healthcareNavigation',
    navIcon: HealthNavNavIcon,
    dashboardIcon: HealthNavIcon,
    dashboardBanner: HealthNavBanner,
    description: m.service_health_nav_description(),
    ariaLabel: m.service_health_nav_aria(),
    landingBrandName: 'Novus Health',
    landingTagline: m.service_health_nav_landing_tagline(),
    landingTitle: m.service_health_nav_landing_title(),
    landingFeatures: [
      m.service_health_nav_landing_feature_1(),
      m.service_health_nav_landing_feature_2(),
      m.service_health_nav_landing_feature_3(),
      m.service_health_nav_landing_feature_4(),
    ],
    landingLearnMoreLabel: m.service_health_nav_landing_btn(),
  },
  {
    name: m.service_legaroo_name(),
    href: '/services/legalTravelAssistance',
    navIcon: LegarooNavIcon,
    dashboardIcon: LegarooIcon,
    dashboardBanner: LegarooBanner,
    description: m.service_legaroo_description(),
    ariaLabel: m.service_legaroo_aria(),
    landingBrandName: 'Legaroo',
    landingTagline: m.service_legaroo_landing_tagline(),
    landingTitle: m.service_legaroo_landing_title(),
    landingFeatures: [
      m.service_legaroo_landing_feature_1(),
      m.service_legaroo_landing_feature_2(),
      m.service_legaroo_landing_feature_3(),
      m.service_legaroo_landing_feature_4(),
    ],
    landingLearnMoreLabel: m.service_legaroo_landing_btn(),
  },
];
